/*
ashraf 10/16/2022  2700520533 added code comments in search, add role management.
akhilaavvaru 10/27/2022 2700520533 role management UX changes
Raghu 10/28/2022 2700520533 Card Styling Fixes
ashraf 10/30/2022 2700520533 conditional tabs render
Suresh Peddavoora 12/05/2022 2700520533 Modified Landing Page Format.
Ashraf 12/05/2022 2700520533 Fixed header labels

*/


import React from 'react';
import Tabs from './Tabs';
import {ErrorSnackbar, SuccessSnackbar} from '../../components/CustomSnackBar';
import {useSelector} from 'react-redux';
import LandingPage from '../LandingPage';

// role management Tabs render (2700520533)
function RoleManagement() {
  const [mainTabValue, setMainTabValue] = React.useState(0);
  const tabLabels = ['Role Management'];


  // handles tab change from search and add role (2700520533)
  const handleChange = (event, newValue) => {
    setMainTabValue(newValue);
  };
  const {errorMsg, successMsg} = useSelector(({addRole}) => addRole);
  return (
    <>
      <LandingPage title={'Administration'} showTabs={true} tabValue={mainTabValue} allAntTabs={tabLabels} handleTabChange={handleChange}>
        <div className="global-field-dash-board">
          <div className={`mb-0`}>
            <div>
              {mainTabValue === 0 ? <Tabs /> : null}
            </div>
          </div>
          {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
          {successMsg && <SuccessSnackbar successMsg={successMsg} />}
        </div>
      </LandingPage>
    </>
  );
}

export default RoleManagement;
